
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutJcfc9uI6x0YgyrYy4iuZBXVmGg9W_45ooih8zY5U3O7g8Meta } from "/src/app/pages/about.vue?macro=true";
import { default as indexlOQXz4qHz1_tjzzS_45_45aw5L3qkduUse1pUPQ2t0gdaSoMeta } from "/src/app/pages/index.vue?macro=true";
import { default as reviewsBkgE7UjpOOWCnOXW7vnj8wtJx7HJr_45Injzkq_reUB1UMeta } from "/src/app/pages/reviews.vue?macro=true";
import { default as prestigeV_kCo7oeQ1mcbgGbDlB4dfsy3MV5Ovruqq4e_45sPBvK8Meta } from "/src/app/pages/prestige.vue?macro=true";
import { default as _91_46_46_46slug_93pTOxn7ysFWyLDiN14Ch5yau8ZXszSeCXd_45fvOeSB5jAMeta } from "/src/app/pages/[...slug].vue?macro=true";
import { default as mediationtDTiae9_UwRBEaVRK2tGAsZf_452UYOaOX8r2fp4DYlWYMeta } from "/src/app/pages/mediation.vue?macro=true";
import { default as housevWWB8YEJxXAQHyWkLl6xB5I7M6r2Kmnzikg783ImvmEMeta } from "/src/app/pages/valuation/house.vue?macro=true";
import { default as indexBRdUpnREIsFcFMgt4j8yOaIrd8YhbLiN7DqmfF8zgf4Meta } from "/src/app/pages/valuation/index.vue?macro=true";
import { default as apartmentUkbnoNloFVzn0Zgn9499qKaAkySSQOWIlTCXfP60uTEMeta } from "/src/app/pages/valuation/apartment.vue?macro=true";
import { default as online_45valuationt_v6aE6B484VDOxjKyLmqY5MqdH5V_45rcRDXbsSDbH40Meta } from "/src/app/pages/valuation/online-valuation.vue?macro=true";
import { default as valuationG6F3SkuUlsY_45Kn7bCgpT31LjyJavt6u6J6H5DSQcJIIMeta } from "/src/app/pages/valuation.vue?macro=true";
import { default as contact_45ustEu_M_45SuLuxe_5AOlHW4sQyYqI_45VCUHqm3btbffQqFwMeta } from "/src/app/pages/contact-us.vue?macro=true";
import { default as indexVrxva_45Yfbddp46dVIuoXxejtTMvm4A6zec3g74hQMSkMeta } from "/src/app/pages/serp/index.vue?macro=true";
import { default as accessibilitydzrELwOl1lVoHRfACQ_458Vsd6vKycVtrrp2rO3j4uMwgMeta } from "/src/app/pages/accessibility.vue?macro=true";
import { default as legal_45mentionstIXK6owXs2ckpj719ZaKdHMdp65B5yiCszNnQO7QkPYMeta } from "/src/app/pages/legal-mentions.vue?macro=true";
import { default as privacy_45policyfn1PJGt4ckiVGqZtLkXe788SgnaOR_pOXk6kMoBq1nkMeta } from "/src/app/pages/privacy-policy.vue?macro=true";
import { default as cookie_45policies5bK9V7kzPYy5lkCaCo35fcbhL_1jlOv3Bg8EgKez_45fMMeta } from "/src/app/pages/cookie-policies.vue?macro=true";
import { default as propertycA5wNy9P8RmYq3MON_yV51voexXAOGB4nVRKb6YQsqkMeta } from "/src/app/pages/redirect/property.vue?macro=true";
import { default as _91_46_46_46serpSlug_93jzMRXPQnGUHtynDzcXhxKwIPj4c4rN29XKLLK2sCDAYMeta } from "/src/app/pages/serp/[...serpSlug].vue?macro=true";
import { default as indexmmJb_tOp6PGSvv8aph72VUgCOpXN4bmjjCJw07VDjw0Meta } from "/src/app/pages/find-real-estate-agent/index.vue?macro=true";
import { default as _91agentSector_93un_45EacVN3bRZgxbDYbCuFdmc_nq29ErQUeCytfGBXXgMeta } from "/src/app/pages/find-real-estate-agent/[agentSector].vue?macro=true";
import { default as find_45real_45estate_45agentwNfXHp_OmSzHCfXRb_KXfRD_45CYyeYBeH4dGTu1x_45gckMeta } from "/src/app/pages/find-real-estate-agent.vue?macro=true";
import { default as _91token_93b19aIuiy7yN0v6M_4560gRDbj9gpQQ5Mla9OUQZZl5HpAMeta } from "/src/app/pages/lead/[answerType]/[token].vue?macro=true";
import { default as unsubscribeL9qrwxE1RnPW6s63HVlMYka8K8cScQsjWVadLn6EYpIMeta } from "/src/app/pages/optins/[token]/unsubscribe.vue?macro=true";
import { default as indexBoKGbAn9CDLISCF9N7Vd_qo_45uDvm8LqTE1TPcEfcN34Meta } from "/src/app/pages/real-estate-agent/[userName]/index.vue?macro=true";
import { default as valuationkOPkdaJ_GpJXy_YTtOSsvMDeEyIztdhLac2l0LyVwc0Meta } from "/src/app/pages/real-estate-agent/[userName]/valuation.vue?macro=true";
import { default as _91userName_93Y5vwjHFcUTW1ksHPa0Rklo7svIwG2I4EH_x55ltWK_MMeta } from "/src/app/pages/real-estate-agent/[userName].vue?macro=true";
import { default as serpnd4_457WzpvTRNbm4RutoLD0eH7eBEkIIpoWCvaCFnOm8Meta } from "/src/app/pages/alerts/[managementToken]/serp.vue?macro=true";
import { default as r_91propertyListingRef_933ZDO1w9e_yFeyyDPTkJaRBty1yYb3Ph6_455iS6hZ4SNMMeta } from "/src/app/pages/property/r[propertyListingRef].vue?macro=true";
import { default as delete9uYKUeLWc7DBUAURmdxs8IP6o0vss6apGuO19rDIKDUMeta } from "/src/app/pages/alerts/[managementToken]/delete.vue?macro=true";
import { default as r_91propertyListingRef_93MWus9dugy58VmAeT3fYsvo25I9flPPRq3U6Bam7WO7AMeta } from "/src/app/pages/property/[propertySlug]/r[propertyListingRef].vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about-iad",
    meta: aboutJcfc9uI6x0YgyrYy4iuZBXVmGg9W_45ooih8zY5U3O7g8Meta || {},
    component: () => import("/src/app/pages/about.vue")
  },
  {
    name: "about___fr",
    path: "/a-propos",
    meta: aboutJcfc9uI6x0YgyrYy4iuZBXVmGg9W_45ooih8zY5U3O7g8Meta || {},
    component: () => import("/src/app/pages/about.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexlOQXz4qHz1_tjzzS_45_45aw5L3qkduUse1pUPQ2t0gdaSoMeta || {},
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/",
    meta: indexlOQXz4qHz1_tjzzS_45_45aw5L3qkduUse1pUPQ2t0gdaSoMeta || {},
    component: () => import("/src/app/pages/index.vue")
  },
  {
    name: "reviews___en",
    path: "/en/reviews",
    meta: reviewsBkgE7UjpOOWCnOXW7vnj8wtJx7HJr_45Injzkq_reUB1UMeta || {},
    component: () => import("/src/app/pages/reviews.vue")
  },
  {
    name: "reviews___fr",
    path: "/avis",
    meta: reviewsBkgE7UjpOOWCnOXW7vnj8wtJx7HJr_45Injzkq_reUB1UMeta || {},
    component: () => import("/src/app/pages/reviews.vue")
  },
  {
    name: "prestige___en",
    path: "/en/prestige",
    meta: prestigeV_kCo7oeQ1mcbgGbDlB4dfsy3MV5Ovruqq4e_45sPBvK8Meta || {},
    component: () => import("/src/app/pages/prestige.vue")
  },
  {
    name: "prestige___fr",
    path: "/prestige",
    meta: prestigeV_kCo7oeQ1mcbgGbDlB4dfsy3MV5Ovruqq4e_45sPBvK8Meta || {},
    component: () => import("/src/app/pages/prestige.vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/src/app/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/:slug(.*)*",
    component: () => import("/src/app/pages/[...slug].vue")
  },
  {
    name: "mediation___en",
    path: "/en/mediation",
    meta: mediationtDTiae9_UwRBEaVRK2tGAsZf_452UYOaOX8r2fp4DYlWYMeta || {},
    component: () => import("/src/app/pages/mediation.vue")
  },
  {
    name: "mediation___fr",
    path: "/mediation",
    meta: mediationtDTiae9_UwRBEaVRK2tGAsZf_452UYOaOX8r2fp4DYlWYMeta || {},
    component: () => import("/src/app/pages/mediation.vue")
  },
  {
    name: valuationG6F3SkuUlsY_45Kn7bCgpT31LjyJavt6u6J6H5DSQcJIIMeta?.name,
    path: "/en/estimate",
    component: () => import("/src/app/pages/valuation.vue"),
    children: [
  {
    name: "valuation-house___en",
    path: "housevilla",
    meta: housevWWB8YEJxXAQHyWkLl6xB5I7M6r2Kmnzikg783ImvmEMeta || {},
    component: () => import("/src/app/pages/valuation/house.vue")
  },
  {
    name: "valuation___en",
    path: "",
    meta: indexBRdUpnREIsFcFMgt4j8yOaIrd8YhbLiN7DqmfF8zgf4Meta || {},
    component: () => import("/src/app/pages/valuation/index.vue")
  },
  {
    name: "valuation-apartment___en",
    path: "apartment",
    meta: apartmentUkbnoNloFVzn0Zgn9499qKaAkySSQOWIlTCXfP60uTEMeta || {},
    component: () => import("/src/app/pages/valuation/apartment.vue")
  },
  {
    name: "valuation-online-valuation___en",
    path: "online-valuation",
    meta: online_45valuationt_v6aE6B484VDOxjKyLmqY5MqdH5V_45rcRDXbsSDbH40Meta || {},
    component: () => import("/src/app/pages/valuation/online-valuation.vue")
  }
]
  },
  {
    name: valuationG6F3SkuUlsY_45Kn7bCgpT31LjyJavt6u6J6H5DSQcJIIMeta?.name,
    path: "/estimer-votre-bien",
    component: () => import("/src/app/pages/valuation.vue"),
    children: [
  {
    name: "valuation-house___fr",
    path: "maison",
    meta: housevWWB8YEJxXAQHyWkLl6xB5I7M6r2Kmnzikg783ImvmEMeta || {},
    component: () => import("/src/app/pages/valuation/house.vue")
  },
  {
    name: "valuation___fr",
    path: "",
    meta: indexBRdUpnREIsFcFMgt4j8yOaIrd8YhbLiN7DqmfF8zgf4Meta || {},
    component: () => import("/src/app/pages/valuation/index.vue")
  },
  {
    name: "valuation-apartment___fr",
    path: "appartement",
    meta: apartmentUkbnoNloFVzn0Zgn9499qKaAkySSQOWIlTCXfP60uTEMeta || {},
    component: () => import("/src/app/pages/valuation/apartment.vue")
  },
  {
    name: "valuation-online-valuation___fr",
    path: "estimateur",
    meta: online_45valuationt_v6aE6B484VDOxjKyLmqY5MqdH5V_45rcRDXbsSDbH40Meta || {},
    component: () => import("/src/app/pages/valuation/online-valuation.vue")
  }
]
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    meta: contact_45ustEu_M_45SuLuxe_5AOlHW4sQyYqI_45VCUHqm3btbffQqFwMeta || {},
    component: () => import("/src/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___fr",
    path: "/contactez-nous",
    meta: contact_45ustEu_M_45SuLuxe_5AOlHW4sQyYqI_45VCUHqm3btbffQqFwMeta || {},
    component: () => import("/src/app/pages/contact-us.vue")
  },
  {
    name: "serp___en",
    path: "/en/ads",
    meta: indexVrxva_45Yfbddp46dVIuoXxejtTMvm4A6zec3g74hQMSkMeta || {},
    component: () => import("/src/app/pages/serp/index.vue")
  },
  {
    name: "serp___fr",
    path: "/annonces",
    meta: indexVrxva_45Yfbddp46dVIuoXxejtTMvm4A6zec3g74hQMSkMeta || {},
    component: () => import("/src/app/pages/serp/index.vue")
  },
  {
    name: "accessibility___en",
    path: "/en/accessibility",
    meta: accessibilitydzrELwOl1lVoHRfACQ_458Vsd6vKycVtrrp2rO3j4uMwgMeta || {},
    component: () => import("/src/app/pages/accessibility.vue")
  },
  {
    name: "accessibility___fr",
    path: "/accessibilite",
    meta: accessibilitydzrELwOl1lVoHRfACQ_458Vsd6vKycVtrrp2rO3j4uMwgMeta || {},
    component: () => import("/src/app/pages/accessibility.vue")
  },
  {
    name: "legal-mentions___en",
    path: "/en/legal-mentions",
    meta: legal_45mentionstIXK6owXs2ckpj719ZaKdHMdp65B5yiCszNnQO7QkPYMeta || {},
    component: () => import("/src/app/pages/legal-mentions.vue")
  },
  {
    name: "legal-mentions___fr",
    path: "/mentions-legales",
    meta: legal_45mentionstIXK6owXs2ckpj719ZaKdHMdp65B5yiCszNnQO7QkPYMeta || {},
    component: () => import("/src/app/pages/legal-mentions.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    meta: privacy_45policyfn1PJGt4ckiVGqZtLkXe788SgnaOR_pOXk6kMoBq1nkMeta || {},
    component: () => import("/src/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/politique-de-confidentialite",
    meta: privacy_45policyfn1PJGt4ckiVGqZtLkXe788SgnaOR_pOXk6kMoBq1nkMeta || {},
    component: () => import("/src/app/pages/privacy-policy.vue")
  },
  {
    name: "cookie-policies___en",
    path: "/en/cookie-management-policy",
    meta: cookie_45policies5bK9V7kzPYy5lkCaCo35fcbhL_1jlOv3Bg8EgKez_45fMMeta || {},
    component: () => import("/src/app/pages/cookie-policies.vue")
  },
  {
    name: "cookie-policies___fr",
    path: "/politique-de-gestion-des-cookies",
    meta: cookie_45policies5bK9V7kzPYy5lkCaCo35fcbhL_1jlOv3Bg8EgKez_45fMMeta || {},
    component: () => import("/src/app/pages/cookie-policies.vue")
  },
  {
    name: "redirect-property___en",
    path: "/en/redirect/property",
    component: () => import("/src/app/pages/redirect/property.vue")
  },
  {
    name: "redirect-property___fr",
    path: "/redirect/property",
    component: () => import("/src/app/pages/redirect/property.vue")
  },
  {
    name: "serp-serpSlug___en",
    path: "/en/ads/:serpSlug(.*)*",
    meta: _91_46_46_46serpSlug_93jzMRXPQnGUHtynDzcXhxKwIPj4c4rN29XKLLK2sCDAYMeta || {},
    component: () => import("/src/app/pages/serp/[...serpSlug].vue")
  },
  {
    name: "serp-serpSlug___fr",
    path: "/annonces/:serpSlug(.*)*",
    meta: _91_46_46_46serpSlug_93jzMRXPQnGUHtynDzcXhxKwIPj4c4rN29XKLLK2sCDAYMeta || {},
    component: () => import("/src/app/pages/serp/[...serpSlug].vue")
  },
  {
    name: find_45real_45estate_45agentwNfXHp_OmSzHCfXRb_KXfRD_45CYyeYBeH4dGTu1x_45gckMeta?.name,
    path: "/en/find-real-estate-agent",
    component: () => import("/src/app/pages/find-real-estate-agent.vue"),
    children: [
  {
    name: "find-real-estate-agent___en",
    path: "",
    meta: indexmmJb_tOp6PGSvv8aph72VUgCOpXN4bmjjCJw07VDjw0Meta || {},
    component: () => import("/src/app/pages/find-real-estate-agent/index.vue")
  },
  {
    name: "find-real-estate-agent-agentSector___en",
    path: ":agentSector()",
    meta: _91agentSector_93un_45EacVN3bRZgxbDYbCuFdmc_nq29ErQUeCytfGBXXgMeta || {},
    component: () => import("/src/app/pages/find-real-estate-agent/[agentSector].vue")
  }
]
  },
  {
    name: find_45real_45estate_45agentwNfXHp_OmSzHCfXRb_KXfRD_45CYyeYBeH4dGTu1x_45gckMeta?.name,
    path: "/trouver-un-conseiller",
    component: () => import("/src/app/pages/find-real-estate-agent.vue"),
    children: [
  {
    name: "find-real-estate-agent___fr",
    path: "",
    meta: indexmmJb_tOp6PGSvv8aph72VUgCOpXN4bmjjCJw07VDjw0Meta || {},
    component: () => import("/src/app/pages/find-real-estate-agent/index.vue")
  },
  {
    name: "find-real-estate-agent-agentSector___fr",
    path: ":agentSector()",
    meta: _91agentSector_93un_45EacVN3bRZgxbDYbCuFdmc_nq29ErQUeCytfGBXXgMeta || {},
    component: () => import("/src/app/pages/find-real-estate-agent/[agentSector].vue")
  }
]
  },
  {
    name: "lead-answerType-token___en",
    path: "/en/lead/:answerType()/:token()",
    meta: _91token_93b19aIuiy7yN0v6M_4560gRDbj9gpQQ5Mla9OUQZZl5HpAMeta || {},
    component: () => import("/src/app/pages/lead/[answerType]/[token].vue")
  },
  {
    name: "lead-answerType-token___fr",
    path: "/lead/:answerType()/:token()",
    meta: _91token_93b19aIuiy7yN0v6M_4560gRDbj9gpQQ5Mla9OUQZZl5HpAMeta || {},
    component: () => import("/src/app/pages/lead/[answerType]/[token].vue")
  },
  {
    name: "optins-token-unsubscribe___en",
    path: "/en/optins/:token()/unsubscribe",
    meta: unsubscribeL9qrwxE1RnPW6s63HVlMYka8K8cScQsjWVadLn6EYpIMeta || {},
    component: () => import("/src/app/pages/optins/[token]/unsubscribe.vue")
  },
  {
    name: "optins-token-unsubscribe___fr",
    path: "/optins/:token()/unsubscribe",
    meta: unsubscribeL9qrwxE1RnPW6s63HVlMYka8K8cScQsjWVadLn6EYpIMeta || {},
    component: () => import("/src/app/pages/optins/[token]/unsubscribe.vue")
  },
  {
    name: _91userName_93Y5vwjHFcUTW1ksHPa0Rklo7svIwG2I4EH_x55ltWK_MMeta?.name,
    path: "/en/real-estate-agent/:userName()",
    component: () => import("/src/app/pages/real-estate-agent/[userName].vue"),
    children: [
  {
    name: "real-estate-agent-userName___en",
    path: "",
    meta: indexBoKGbAn9CDLISCF9N7Vd_qo_45uDvm8LqTE1TPcEfcN34Meta || {},
    component: () => import("/src/app/pages/real-estate-agent/[userName]/index.vue")
  },
  {
    name: "real-estate-agent-userName-valuation___en",
    path: "estimate",
    meta: valuationkOPkdaJ_GpJXy_YTtOSsvMDeEyIztdhLac2l0LyVwc0Meta || {},
    component: () => import("/src/app/pages/real-estate-agent/[userName]/valuation.vue")
  }
]
  },
  {
    name: _91userName_93Y5vwjHFcUTW1ksHPa0Rklo7svIwG2I4EH_x55ltWK_MMeta?.name,
    path: "/conseiller-immobilier/:userName()",
    component: () => import("/src/app/pages/real-estate-agent/[userName].vue"),
    children: [
  {
    name: "real-estate-agent-userName___fr",
    path: "",
    meta: indexBoKGbAn9CDLISCF9N7Vd_qo_45uDvm8LqTE1TPcEfcN34Meta || {},
    component: () => import("/src/app/pages/real-estate-agent/[userName]/index.vue")
  },
  {
    name: "real-estate-agent-userName-valuation___fr",
    path: "estimation",
    meta: valuationkOPkdaJ_GpJXy_YTtOSsvMDeEyIztdhLac2l0LyVwc0Meta || {},
    component: () => import("/src/app/pages/real-estate-agent/[userName]/valuation.vue")
  }
]
  },
  {
    name: "alerts-managementToken-serp___en",
    path: "/en/alerts/:managementToken()/serp",
    component: () => import("/src/app/pages/alerts/[managementToken]/serp.vue")
  },
  {
    name: "alerts-managementToken-serp___fr",
    path: "/alerts/:managementToken()/serp",
    component: () => import("/src/app/pages/alerts/[managementToken]/serp.vue")
  },
  {
    name: "property-rpropertyListingRef___en",
    path: "/en/ad/r:propertyListingRef()",
    meta: r_91propertyListingRef_933ZDO1w9e_yFeyyDPTkJaRBty1yYb3Ph6_455iS6hZ4SNMMeta || {},
    component: () => import("/src/app/pages/property/r[propertyListingRef].vue")
  },
  {
    name: "property-rpropertyListingRef___fr",
    path: "/annonce/r:propertyListingRef()",
    meta: r_91propertyListingRef_933ZDO1w9e_yFeyyDPTkJaRBty1yYb3Ph6_455iS6hZ4SNMMeta || {},
    component: () => import("/src/app/pages/property/r[propertyListingRef].vue")
  },
  {
    name: "alerts-managementToken-delete___en",
    path: "/en/alerts/:managementToken()/delete",
    meta: delete9uYKUeLWc7DBUAURmdxs8IP6o0vss6apGuO19rDIKDUMeta || {},
    component: () => import("/src/app/pages/alerts/[managementToken]/delete.vue")
  },
  {
    name: "alerts-managementToken-delete___fr",
    path: "/alerts/:managementToken()/delete",
    meta: delete9uYKUeLWc7DBUAURmdxs8IP6o0vss6apGuO19rDIKDUMeta || {},
    component: () => import("/src/app/pages/alerts/[managementToken]/delete.vue")
  },
  {
    name: "property-propertySlug-rpropertyListingRef___en",
    path: "/en/ad/:propertySlug()/r:propertyListingRef()",
    component: () => import("/src/app/pages/property/[propertySlug]/r[propertyListingRef].vue")
  },
  {
    name: "property-propertySlug-rpropertyListingRef___fr",
    path: "/annonce/:propertySlug()/r:propertyListingRef()",
    component: () => import("/src/app/pages/property/[propertySlug]/r[propertyListingRef].vue")
  }
]